<script setup>
import { computed } from 'vue'
import { useLocaleStore } from '@/stores/localeStore'
import networkData from '@/data/network-data.json'
import NextButton from '../NextButton.vue'
import PreviousButton from '../PreviousButton.vue'

defineEmits(['open-window', 'minimize-window'])

const localeStore = useLocaleStore()
const currentLocale = computed(() => localeStore.currentLocale)

const network = computed(() => {
  return networkData[currentLocale.value]?.network || {}
})

const contacts = computed(() => {
  return network.value.contacts || []
})
</script>

<template>
  <div class="relative right-0 h-content-window overflow-hidden">
    <div class="w-full h-full bg-white overflow-auto p-2 pb-28">
      <div>
        <section class="mt-2">
          <h2 class="font-trebuchet-pixel underline text-base mb-3">{{ network.title }}</h2>
          <p class="text-xs mb-4 text-gray-700">{{ network.description }}</p>

          <!-- Summary section -->
          <div v-if="network.summary" class="mb-6 p-4 bg-blue-50 border-l-4 border-blue-500 rounded">
            <h3 class="font-trebuchet-pixel text-sm font-semibold mb-2 text-blue-900">{{ $t('windows.reseau.summaryTitle') || 'Ce que j\'ai retenu' }}</h3>
            <p class="text-xs text-gray-800 leading-relaxed">{{ network.summary }}</p>
          </div>

          <!-- Certificate section -->
          <div v-if="network.certificate && network.certificate.image" class="mb-6">
            <div class="flex justify-center">
              <img 
                :src="network.certificate.image" 
                alt="MyJobGlasses Certificate" 
                class="max-w-full h-auto rounded"
              />
            </div>
          </div>

          <div class="space-y-4">
            <div v-for="contact in contacts" :key="contact.id" class="border border-gray-300 p-4 rounded">
              <div class="flex items-start justify-between mb-2">
                <div class="flex-1">
                  <h3 class="font-trebuchet-pixel font-semibold text-sm">{{ contact.name }}</h3>
                  <div class="flex items-center gap-2 mt-1 flex-wrap">
                    <span class="text-xxs text-gray-600">{{ contact.position }}</span>
                    <span class="text-xxs text-gray-600">•</span>
                    <span class="text-xxs text-gray-600">{{ contact.company }}</span>
                  </div>
                  <div class="flex items-center gap-2 mt-1">
                    <span class="text-xxs bg-green-100 px-2 py-0.5 rounded">{{ contact.type }}</span>
                    <span class="text-xxs text-gray-600">{{ contact.date }}</span>
                  </div>
                </div>
              </div>

              <div class="mt-3">
                <h4 class="font-trebuchet-pixel text-xs font-semibold mb-1">{{ $t('windows.reseau.context') }}:</h4>
                <p class="text-xs text-gray-700 mb-2">{{ contact.context }}</p>
              </div>

              <div v-if="contact.learnings && contact.learnings.length > 0">
                <h4 class="font-trebuchet-pixel text-xs font-semibold mb-1">{{ $t('windows.reseau.learnings') }}:</h4>
                <ul class="list-disc list-inside text-xxs ml-2 space-y-1 text-gray-700">
                  <li v-for="learning in contact.learnings" :key="learning">{{ learning }}</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
      <PreviousButton current-window-id="reseau" @open-window="$emit('open-window', $event)" @minimize-window="$emit('minimize-window', $event)" />
      <NextButton current-window-id="reseau" @open-window="$emit('open-window', $event)" @minimize-window="$emit('minimize-window', $event)" />
    </div>
  </div>
</template>
